<form [formGroup]="formGroup">
    <div class="container content" *ngIf="rate">
        <div class="row">
            <div class="col-lg-12">
                <h5 class="title-step" align="center">
                    <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
                    Tarifa fijo y móvil

                    <span class="rate-edit" (click)="editRate()">
                        <fa-icon matDatepickerToggleIcon [icon]="faPen"></fa-icon>
                        Cambiar tarifa
                    </span>
                </h5>
                <div class="card card-default card-horizontal mb-5">
                    <div class="card-heading">
                        <div class="row">
                            <div class="col-lg-6">
                                <h5 align="left" class="tar-name car-tar-1 my-3">{{ rate.name }}</h5>
                            </div>
                            <div class="col-lg-6 my-auto">
                                <h5 align="left" class="tar-price car-tar-2 my-3">
                                    {{ rate.price.split('.')[0] }}<span>,{{ rate.price.split('.')[1] }}€/mes</span>
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="!thereIsOffer(rate, 'data')">
                                    <b>{{ rate.data }}</b> de navegación
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="thereIsOffer(rate, 'data')">
                                    <b>{{ rate?.offers[0]?.data }}</b> de navegación
                                </h5>

                                <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.speed && rate.speed != ''">
                                    <b>{{ rate.speed }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.extra_info_1 && rate.extra_info_1 != ''">
                                    <b class="line-break">{{ rate?.extra_info_1 }}</b>
                                </h5>
                            </div>
                            <div class="col-md-auto"><span class="vl mobile"></span></div>
                            <div class="col-md-5 my-auto">
                                <h5 align="left" class="tar-name-5 my-0"
                                    *ngIf="rate.voice && rate.voice != ''">
                                    <b>{{ rate.voice }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0"
                                    *ngIf="rate.extra_info_2 && rate.extra_info_2 != ''">
                                    <b class="line-break">{{ rate.extra_info_2 }}</b>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="container content">
        <div class="row">
            <div class="col-lg-12">
                <h5 class="title-step" align="center">
                    <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20">
                    Tipo de operación línea fija
                </h5>

                <div class="card">
                    <div class="card-header background-grey">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div class="radio-btn-group" ngbRadioGroup name="typeOperation"
                                     formControlName="type_operation"
                                     (change)="changeTypeOperation()"
                                     [(ngModel)]="model.type_operation">
                                    <h6 class="subtitulo-pack">Tipo: </h6>

                                    <div class="radio radio-pack" *ngIf="model.type_operation !== 'migration'">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="registration" [checked]="model.type_operation == 'registration'"/>
                                            Alta nueva
                                        </label>
                                    </div>

                                    <div class="radio radio-pack" *ngIf="model.type_operation !== 'migration'">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="portability"
                                                   [checked]="model.type_operation == 'portability'"/>
                                            Portabilidad
                                        </label>
                                    </div>

                                    <div class="radio radio-pack" *ngIf="model.type_operation === 'migration'">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="migration"
                                                   [checked]="model.type_operation == 'migration'"/>
                                            Migración
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul class="list-group list-group-flush" *ngIf="model.type_operation === 'portability'">
                        <li class="list-group-item cuerpo-pack">
                            <!-- <h6 class="subtitulo-pack-form" *ngIf="model.type_operation == 'portability'">Datos de alta / portabilidad</h6> -->

                            <div class="form-row">
                                <div class="col-lg-3 mt-1">
                                    <mat-form-field>
                                        <mat-label>Línea fija a portar</mat-label>
                                        <input type="text" matInput formControlName="phone_portability" maxlength="9">
                                    </mat-form-field>
                                </div>

                                <div class="col-lg-2 mt-1">
                                    <mat-form-field>
                                        <mat-label>Operador donante</mat-label>

                                        <select matNativeControl formControlName="operator_portability">
                                            <option *ngFor="let provider of providers" [value]="provider.service_provider_id">{{ provider.name }}</option>
                                        </select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <ul class="list-group list-group-flush" *ngIf="model.type_operation === 'migration'">
                        <li class="list-group-item cuerpo-pack">
                            <!-- <h6 class="subtitulo-pack-form" *ngIf="model.type_operation == 'migration'">Datos de migración</h6> -->

                            <div class="form-row">
                                <div class="col-lg-3 mt-1">
                                    <mat-form-field>
                                        <mat-label>Línea fija a migrar</mat-label>
                                        <input type="text" matInput formControlName="phone_portability">
                                    </mat-form-field>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div align="center">
            <br>
            <button class="btn btn-black-outline btn-block mb-1" (click)="validate()">
                Continuar
                <img src="./assets/img/arrow-right.svg" class="img-fluid ico-title" width="15">
            </button>
            <!--<button class="btn btn-grey-outline2 btn-block mb-5" role="button" (click)="back()">
                Volver
            </button>-->
            <br><br>
        </div>
    </div>
</form>
